export type { CommonLayoutProps } from "./CommonLayout.type";
import CommonLayout from "./CommonLayout";
export default CommonLayout;
